import { IChangeLocationAction, IOpenModalAction, IHideNotificationMessageAction, IAddToastMessageAction } from "./actions";
import { animateScroll as scroll } from "react-scroll";
import { AppLocation, AppThunkAction } from "../typings";

const CHANGE_LOCATION = "CHANGE_LOCATION";
const MODAL_STATUS_CHANGE = "MODAL_STATUS_CHANGE";
const HIDE_TOAST_MESSAGE = "HIDE_TOAST_MESSAGE";
const ADD_TOAST_MESSAEG = "ADD_TOAST_MESSAGE";

export const actions = {
    /*removeToastMessage: (id: string): AppThunkAction<IHideNotificationMessageAction> => {
        return (dispatch, getState) => {
            dispatch({
                type: HIDE_TOAST_MESSAGE,
                id
            });
        }
    },
    addToastMessage: (id: string, type: 'success' | 'error' | 'warn' | 'info', title: string, description: string, deadline: number): AppThunkAction<IAddToastMessageAction> => {
        return (dispatch, getState) => {
            dispatch({
                type: ADD_TOAST_MESSAEG,
                messageType: type,
                deadline,
                description,
                title,
                id
            })
        }
    },*/
    setModalOpen: (opened: boolean): AppThunkAction<IOpenModalAction> => {
        return (dispatch, getState) => {
            dispatch({ type: MODAL_STATUS_CHANGE, opened });
        };
    },
    changeLocation: (appLocation: AppLocation): AppThunkAction<IChangeLocationAction> => {
        return (dispatch, getState) => {
            dispatch({ type: CHANGE_LOCATION, appLocation });

            scroll.scrollToTop({
                duration: 0,
            });
        };
    },
};



// WEBPACK FOOTER //
// ./src/actions/main.actions.ts